import React, {Component} from "react";
import "./Account.scss";
import {connect} from "react-redux";
import {
    getBusinessDetails,
    getUserDetails,
    logout,
    updateBusinessAddress,
    updateBusinessDetails
} from "../../../actions/user";
import {withRouter} from "react-router-dom";
import {addLogo, changePassword, deleteLogo, updateBusinessConfigurations} from "../../../actions/account";
import {askForConfirmation, imageObjectToUrl, successToast} from "../../../utils";
import {withTranslation} from "react-i18next";
import {setLoading} from "../../../actions";
import Input from "../../../components/Input/Input";
import Button, {ButtonColors, ButtonSizes, ButtonTypes} from "../../../components/Button/Button";
import {inputValidations, validationTests} from "../../../utils/validation/configurations";
import {validate} from "../../../utils/validation";
import moment from "moment";
import {ReactComponent as ProfileIcon} from "../../../assets/icons/profile-1.svg";
import {ReactComponent as SettingsIcon} from "../../../assets/icons/gear.svg";
import {ReactComponent as LockIcon} from "../../../assets/icons/password.svg";
import {ReactComponent as ArrowRightIcon} from "../../../assets/icons/right.svg";
import {ACCOUNT_PAGE_TABS} from "../../../utils/constants";
import {unregister} from "../../../actions/notifications";
import {ReactComponent as LogoutIcon} from "../../../assets/icons/sign-out.svg";
import {ReactComponent as CheckmarkIcon} from "../../../assets/icons/approve.svg"
import classNames from "classnames";

const blank_image_url = "https://filestore.community.support.microsoft.com/api/images/72e3f188-79a1-465f-90ca-27262d769841";

class Account extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            business: {
                id: "",
                name: "",
                phoneNumber: "",
                address: {
                    addressLine: "",
                    city: "",
                    country: "",
                    latitude: "",
                    longitude: ""
                },
                configuration: {
                    language: ""
                },
                startDayTime: moment("2020-10-10 00:00:00").format("HH:mm") + ":00",
                endDayTime: moment("2020-10-10 00:00:00").format("HH:mm") + ":00",
                logo: "",
                radiusInMeters: "",
                enableCallWaiter: true
            },
            logo: null,
            currentTab: ACCOUNT_PAGE_TABS.PROFILE,
            showValidations: false,
            showPopup: false,
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            incorrectCurrentPassword: false
        }
    }

    logoInputRef = null;

    languageOptions = [
        { label: "Shqip", value: "sq" },
        { label: "Française", value: "fr" },
        { label: "English", value: "en" },
        { label: "Nederlands", value: "nl" },
    ];

    componentDidMount() {
        this.props.getBusinessDetails().then(res => {
            this.setState({business: res.data});
        })

        this.props.getUserDetails().then(res => {
            this.setState({user: res.data});
        })

        document.querySelector("section.content").classList.add("p-0")
    }

    componentWillUnmount() {
        document.querySelector("section.content").classList.remove("p-0")
    }

    handleSubmit = async() => {
        const {t} = this.props;

        if (this.formIsInvalid()) {
            this.setState({showValidations: true});
            return;
        }

        if (!await askForConfirmation(t("Do you want to continue?"))) {
            return;
        }

        this.props.setLoading(true);

    }

    uploadLogo = async() => {
        const {t} = this.props;

        if (!await askForConfirmation(t("Do you want to continue?"))) {
            return;
        }

        this.props.setLoading(true);
        this.props.addLogo(this.state.logo).then(res => {
            this.props.getBusinessDetails();
            this.props.setLoading(false);
            successToast(t("Updated logo!"))
        })
    }


    deleteLogo = async() => {
        const {t} = this.props;

        if (!await askForConfirmation(t("Do you want to continue?"))) {
            return;
        }

        this.props.setLoading(true);
        this.props.deleteLogo().then(res => {
            this.props.getBusinessDetails();
            this.props.setLoading(false);
            this.setState({logo: null, business: {...this.state.business, logo: ""}});
            successToast(t("Removed logo!"))
        })
    }

    formIsInvalid = () => {
        const {business} = this.state;
        return validate(inputValidations.accountNameInput, business.name) ||
            validate(inputValidations.accountAddressInput, business.address.addressLine) ||
            validate(inputValidations.accountPhoneInput, business.phoneNumber) ||
            validate(inputValidations.accountCityInput, business.address.city) ||
            validate(inputValidations.accountCountryInput, business.address.country) ||
            validate(inputValidations.accountLatitudeInput, business.address.latitude) ||
            validate(inputValidations.accountLongitudeInput, business.address.longitude) ||
            validate(inputValidations.accountDistanceInput, business.radiusInMeters);
    }

    logout = () => {
        this.props.unregister();
        this.props.logout()
        this.props.history.push("/");
    }

    debounce = null;

    onBusinessDetailsChange = (name, value) => {
        const {business} = this.state;

        this.setState({
            business: {...business, [name]: value}
        }, () => {
            if(this.formIsInvalid()) {
                return;
            }
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.props.updateBusinessDetails(this.state.business, business.id)
                    .then(res => this.showSuccessPopup());
            }, 500);
        })

    }

    onBusinessAddressChange = (name, value) => {
        const {business} = this.state;
        this.setState({
            business: {...business, address: {...business.address, [name]: value}}
        }, () => {
            if(this.formIsInvalid()) {
                return;
            }
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.props.updateBusinessAddress(this.state.business.address, business.id)
                    .then(res => this.showSuccessPopup())
            }, 500);
        });
    }

    onBusinessConfigurationChange = (name, value) => {
        const {business} = this.state;
        this.setState({
            business: {...business, configuration: {...business.configuration, [name]: value}}
        }, () => {
            if(this.formIsInvalid()) {
                return;
            }
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.props.updateBusinessConfigurations(this.state.business.configuration, business.id)
                    .then(res => this.showSuccessPopup())
            }, 500);
        });
    }

    showSuccessPopup = () => {
        this.setState({showPopup: true},
            () => {
                setTimeout(() => {
                    this.setState({showPopup: false});
                }, 1000)
            });
    }

    changePassword = () => {
        const {currentPassword, newPassword, confirmNewPassword} = this.state;
        if(!currentPassword || !newPassword || !confirmNewPassword || (newPassword !== confirmNewPassword)) {
            this.setState({showValidations: true});
            return;
        }

        const payload = {
            oldPassword: currentPassword,
            newPassword: newPassword
        }
        this.props.changePassword(payload)
            .then(res => {
                console.log(res);
                this.showSuccessPopup();
                this.setState({
                    currentTab: null,
                    incorrectCurrentPassword: !res.data
                });

                this.setState({
                    currentPassword: "",
                    newPassword: "",
                    confirmNewPassword: "",
                    showValidations: false,
                    currentTab: ACCOUNT_PAGE_TABS.PASSWORD
                })
            });
    }

    customNewPasswordValidationMessage = () => {
        const {newPassword, confirmNewPassword} = this.state;
        if(newPassword && confirmNewPassword && (newPassword !== confirmNewPassword)) {
            return "Fjalëkalimi duhet të jetë i njejtë";
        }
        return null;
    }

    customCurrentPasswordValidationMessage = () => {
        const {incorrectCurrentPassword} = this.state;
        if(incorrectCurrentPassword) {
            return "Fjalëkalimi i tanishëm është i gabuar";
        }
        return null;
    }

    render() {

        const {business, logo, showValidations, currentTab, showPopup, currentPassword, newPassword, confirmNewPassword, user} = this.state;
        const {t} = this.props;

        return (
            <div className="account-page">

                <div className={classNames("account-page-popup", {"active": showPopup})}>
                    <CheckmarkIcon/> {t("Changes were saved successfully")}
                </div>


                <div className="account-page-sidebar">
                    <h1>Settings</h1>

                    <ul className="list-menu">
                        <li onClick={() => this.setState({currentTab: ACCOUNT_PAGE_TABS.PROFILE})}>
                            <span><ProfileIcon className="mr-12"/>{t("Profile")}</span>
                            <ArrowRightIcon/>
                        </li>
                        <li onClick={() => this.setState({currentTab: ACCOUNT_PAGE_TABS.CONFIGURATIONS})}>
                            <span><SettingsIcon className="mr-12"/>{t("Configurations")}</span>
                            <ArrowRightIcon/>
                        </li>
                        <li onClick={() => this.setState({currentTab: ACCOUNT_PAGE_TABS.PASSWORD})}>
                            <span><LockIcon className="mr-12"/>{t("Password")}</span>
                            <ArrowRightIcon/>
                        </li>
                    </ul>


                    <Button
                        onClick={this.logout}
                        type={ButtonTypes.Filled}
                        size={ButtonSizes.Full}
                        color={ButtonColors.Gray}
                        className="logout-button">
                        <LogoutIcon className="mr-12"/> {t("Log out")}
                    </Button>

                </div>
                <div className="account-page-content">

                    {currentTab === ACCOUNT_PAGE_TABS.PROFILE && <div className="profile-tab">


                        <div className="row mb-32">
                            <div className="col-12">
                                <div className="business-logo"
                                     style={{backgroundImage: "url(" + (business.logo || blank_image_url) + ")"}}/>
                                <input className="d-none"
                                       type="file"
                                       ref={ref => this.logoInputRef = ref}
                                       onChange={e => {
                                           const file = e.target.files?.[0];
                                           if (file) {
                                               this.setState({
                                                   logo: file,
                                                   business: {...business, logo: imageObjectToUrl(file)}
                                               }, () => {
                                                   this.uploadLogo();
                                               });
                                           }
                                       }}/>

                                <div className="row mt-5">
                                    <div className="col-6">
                                        <Button
                                            className="float-right"
                                            color={ButtonColors.Green}
                                            type={ButtonTypes.Filled}
                                            size={ButtonSizes.Small}
                                            onClick={() => this.logoInputRef.click()}>
                                            {t("Add logo")}
                                        </Button>
                                    </div>

                                    {(logo || business.logo) &&
                                    <div className="col-6">
                                        <Button
                                            className="float-left"
                                            color={ButtonColors.Red}
                                            type={ButtonTypes.Filled}
                                            size={ButtonSizes.Small}
                                            onClick={e => this.deleteLogo()}>
                                            {t("Remove logo")}
                                        </Button>
                                    </div>}
                                </div>
                            </div>

                        </div>

                        <div className="row mb-24">
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("Name")}
                                    id="accountNameInput"
                                    name="accountNameInput"
                                    value={business.name}
                                    validations={[inputValidations.accountNameInput, showValidations]}
                                    onChange={(e) => this.onBusinessDetailsChange("name", e.target.value)}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("Address")}
                                    id="accountAddressInput"
                                    name="accountAddressInput"
                                    value={business.address.addressLine}
                                    validations={[inputValidations.accountAddressInput, showValidations]}
                                    onChange={e => this.onBusinessAddressChange("addressLine", e.target.value)}/>
                            </div>

                        </div>
                        <div className="row mb-24">
                            <div className="col-12 col-md-6">
                                <Input
                                    disabled
                                    label={t("Email")}
                                    id="accountEmailInput"
                                    name="accountEmailInput"
                                    value={user?.email}
                                    // validations={[inputValidations.accountPhoneInput, showValidations]}
                                    onChange={e => null}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("Phone")}
                                    id="accountPhoneInput"
                                    name="accountPhoneInput"
                                    value={business.phoneNumber}
                                    validations={[inputValidations.accountPhoneInput, showValidations]}
                                    onChange={e => this.onBusinessDetailsChange("phoneNumber", e.target.value)}/>
                            </div>
                        </div>
                        <div className="row mb-24">
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("Country")}
                                    id="accountCountryInput"
                                    name="accountCountryInput"
                                    value={business.address.country}
                                    validations={[inputValidations.accountCountryInput, showValidations]}
                                    onChange={e => this.onBusinessAddressChange("country", e.target.value)}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("City")}
                                    id="accountCityInput"
                                    name="accountCityInput"
                                    value={business.address.city}
                                    validations={[inputValidations.accountCityInput, showValidations]}
                                    onChange={e => this.onBusinessAddressChange("city", e.target.value)}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <Input
                                    type="textarea"
                                    label={`${t("Description")} (${t("Primary language")})`}
                                    id="accountDescriptionInput"
                                    name="accountDescriptionInput"
                                    value={business.description}
                                    validations={[inputValidations.accountDescription, showValidations]}
                                    onChange={e => this.onBusinessDetailsChange("description", e.target.value)}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    type="textarea"
                                    label={`${t("Description")} (${t("Secondary language")})`}
                                    id="accountDescriptionEnInput"
                                    name="accountDescriptionEnInput"
                                    value={business.descriptionEn}
                                    validations={[inputValidations.accountDescriptionEn, showValidations]}
                                    onChange={e => this.onBusinessDetailsChange("descriptionEn", e.target.value)}/>
                            </div>
                        </div>
                    </div>}


                    {currentTab === ACCOUNT_PAGE_TABS.CONFIGURATIONS && <div className="configurations-tab">
                        <p className="mb-16"><b>{t("Working hours")}</b></p>
                        <div className="row mb-24">
                            <div className="col-12 col-md-6">
                                <Input
                                    type="time"
                                    label={t("Start day time")}
                                    id="accountStartDayTimeInput"
                                    name="accountStartDayTimeInput"
                                    value={business.startDayTime}
                                    validations={[inputValidations.accountStartDayTime, showValidations]}
                                    onChange={time => this.onBusinessDetailsChange("startDayTime", time)}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    type="time"
                                    label={t("End day time")}
                                    id="accountEndDayTimeInput"
                                    name="accountEndDayTimeInput"
                                    value={business.endDayTime}
                                    validations={[inputValidations.accountEndDayTime, showValidations]}
                                    onChange={time => this.onBusinessDetailsChange("endDayTime", time)}/>
                            </div>
                        </div>

                        {/*<p className="mb-16"><b>{t("Location")}</b></p>*/}
                        {/*<div className="row mb-24">*/}
                        {/*    <div className="col">*/}
                        {/*        <Input*/}
                        {/*            label={t("Latitude")}*/}
                        {/*            id="accountLatitudeInput"*/}
                        {/*            name="accountLatitudeInput"*/}
                        {/*            value={business.address.latitude}*/}
                        {/*            validations={[inputValidations.accountLatitudeInput, showValidations]}*/}
                        {/*            onChange={e => this.onBusinessAddressChange("latitude", e.target.value)}/>*/}
                        {/*    </div>*/}
                        {/*    <div className="col">*/}
                        {/*        <Input*/}
                        {/*            label={t("Longitude")}*/}
                        {/*            id="accountLongitudeInput"*/}
                        {/*            name="accountLongitudeInput"*/}
                        {/*            value={business.address.longitude}*/}
                        {/*            validations={[inputValidations.accountLongitudeInput, showValidations]}*/}
                        {/*            onChange={e => this.onBusinessAddressChange("longitude", e.target.value)}/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/*<p className="mb-16"><b>{t("Call waiter")}</b></p>*/}
                        {/*<div className="row">*/}
                        {/*    <div className="col">*/}
                        {/*        <Input*/}
                        {/*            type="switch"*/}
                        {/*            label={t("Enable call waiter")}*/}
                        {/*            id="accountWaiterInput"*/}
                        {/*            name="accountWaiterInput"*/}
                        {/*            value={business.enableCallWaiter}*/}
                        {/*            onChange={(value) => this.onBusinessDetailsChange("enableCallWaiter", value)}/>*/}
                        {/*    </div>*/}
                        {/*    <div className="col">*/}
                        {/*        <Input*/}
                        {/*            label={t("Call waiter distance")}*/}
                        {/*            id="accountDistanceInput"*/}
                        {/*            name="accountDistanceInput"*/}
                        {/*            value={business.radiusInMeters}*/}
                        {/*            validations={[inputValidations.accountDistanceInput, showValidations]}*/}
                        {/*            onChange={(e) => this.onBusinessDetailsChange("radiusInMeters", e.target.value)}/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <p className="mb-16 mt-16"><b>{t("Language")}</b></p>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("Primary language")}
                                    type="select"
                                    id="accountLanguageInput"
                                    name="accountLanguageInput"
                                    value={business.configuration.language}
                                    options={this.languageOptions}
                                    onChange={(e) => this.onBusinessConfigurationChange("language", e.target.value)}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    label={t("Secondary language")}
                                    type="select"
                                    id="accountSecondaryLanguageInput"
                                    name="accountSecondaryLanguageInput"
                                    value={business.configuration.secondaryLanguage}
                                    options={this.languageOptions}
                                    onChange={(e) => this.onBusinessConfigurationChange("secondaryLanguage", e.target.value)}/>
                            </div>
                        </div>
                    </div>}

                    {currentTab === ACCOUNT_PAGE_TABS.PASSWORD &&
                    <div className="reset-password-tab">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <Input
                                    type="password"
                                    label={t("Current password")}
                                    id="accountCurrentPasswordInput"
                                    name="accountCurrentPasswordInput"
                                    value={currentPassword}
                                    validations={[[validationTests.isNotEmpty], showValidations]}
                                    customValidationMessage={this.customCurrentPasswordValidationMessage()}
                                    onChange={(e) => this.setState({
                                        currentPassword: e.target.value,
                                        incorrectCurrentPassword: false
                                    })}/>
                            </div>
                            <div className="col-12 col-md-6" />
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 col-md-6">
                                <Input
                                    type="password"
                                    label={t("New password")}
                                    id="accountNewPasswordInput"
                                    name="accountNewPasswordInput"
                                    value={newPassword}
                                    validations={[[validationTests.isNotEmpty], showValidations]}
                                    customValidationMessage={this.customNewPasswordValidationMessage()}
                                    onChange={(e) => this.setState({ newPassword: e.target.value })}/>
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    type="password"
                                    label={t("Re-enter new password")}
                                    id="accountConfirmNewPasswordInput"
                                    name="accountConfirmNewPasswordInput"
                                    value={confirmNewPassword}
                                    validations={[[validationTests.isNotEmpty], showValidations]}
                                    customValidationMessage={this.customNewPasswordValidationMessage()}
                                    onChange={(e) => this.setState({ confirmNewPassword: e.target.value })}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <Button
                                    className="mt-5"
                                    onClick={this.changePassword}
                                    type={ButtonTypes.Filled}
                                    size={ButtonSizes.Full}
                                    color={ButtonColors.Green}>
                                    {t("Submit")}
                                </Button>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        user_details: state.app.user_details,
        user_account_details: state.app.user_account_details,
    }
}

const mapDispatchToProps = dispatch => (
    {
        setLoading: data => dispatch(setLoading(data)),
        addLogo: data => dispatch(addLogo(data)),
        deleteLogo: data => dispatch(deleteLogo(data)),
        getUserDetails: data => dispatch(getUserDetails(data)),
        getBusinessDetails: data => dispatch(getBusinessDetails(data)),
        updateBusinessDetails: (data, id) => dispatch(updateBusinessDetails(data, id)),
        updateBusinessAddress: (data, id) => dispatch(updateBusinessAddress(data, id)),
        updateBusinessConfigurations: (data, id) => dispatch(updateBusinessConfigurations(data, id)),
        logout: data => dispatch(logout(data)),
        unregister: data => dispatch(unregister(data)),
        changePassword: data => dispatch(changePassword(data)),
    }
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Account)));
